<template>
  <div>
    <span style="display:none">{{loadedScenario}}</span>
    <label class="label">Название сценария</label>
        <p class="control">
          <input v-model="scenario.name" class="input" type="text" placeholder="Введите название сценария">
        </p>
        <div>
          <label class="label control">Вопрос 1 <input v-model="scenario.parameters.questionFirstKey" placeholder="Введите ключ вопроса" class="input questionKey"></label>
          <p class="control">
            <input type="radio" v-model="scenario.parameters.questionFirstGenerationState"
                   v-bind:value="false"
                   @change="onChangeGenerationState('questionFirstGenerationState', 'questionFirstAudio', 'questionFirstGeneratedAudio', 'questionFirstLoadedAudio', 'onQuestionFirst')">
            <label>Загрузить аудио</label>
            <br/>
            <input type="radio" v-model="scenario.parameters.questionFirstGenerationState"
                   v-bind:value="true"
                   @change="onChangeGenerationState('questionFirstGenerationState', 'questionFirstAudio', 'questionFirstGeneratedAudio', 'questionFirstLoadedAudio', 'onQuestionFirst')">
            <label>Сгенерировать аудио</label>
          </p>
          <div v-if="scenario.parameters.questionFirstGenerationState">
            <p class="control">
              <textarea v-model="scenario.parameters.questionFirstText" class="textarea"></textarea>
            <div class="control is-grouped">
              <button class="button is-primary" v-on:click="genAudio('questionFirstId', 'questionFirstAudio', 'currentSpeakerFirst', 'questionFirstGeneratedAudio', 'questionFirstText', 'questionFirstLoading', 'First question', 'currentEmotionFirst', 'currentSpeedFirst')">
                <span class="icon">
                  <i class="fa fa-magic"></i>
                </span>
                <div class="loader spinner" v-if="tmp.questionFirstLoading"></div>
                Сгенерировать аудио
              </button>

              <div class="select is-primary">
                <select v-model="tmp.currentSpeakerFirst" class="form-control">
                  <option v-for="speaker in speakerList">
                    {{speaker.value}}
                  </option>
                </select>
              </div>
              <div class="select is-primary">
                <select v-model="tmp.currentEmotionFirst" class="form-control">
                  <option v-for="emotion in emotionList">
                    {{emotion.value}}
                  </option>
                </select>
              </div>
              <p>
                <slider size="small" v-bind:value="tmp.currentSpeedFirst" :min="0.1" :step="0.1" :max="3" @change="tmp.currentSpeedFirst = $event"></slider>
                Скорость:&nbsp{{tmp.currentSpeedFirst}}
              </p>

              <audio v-if="tmp.questionFirstGeneratedAudio" :ref="'onQuestionFirst'">
                <source v-bind:src="scenario.parameters.questionFirstAudio">
                Ваш браузер не поддерживает html5 audio. Попробуйте chrome.
              </audio>
              <audio-player v-if="tmp.questionFirstGeneratedAudio" :file="scenario.parameters.questionFirstAudio"/>
            </div>
            </p>
          </div>
          <div v-if="!scenario.parameters.questionFirstGenerationState">
            <p class="control">
            <div class="control">
              <input class="button is-info" type="button" value="Загрузить из файла" @click="uploadFile('questionFirstLoadedAudio')">
              <input style="display:none;" @input="loadAudio('questionFirstLoadedAudio', 'questionFirstId', 'questionFirstAudio', 'questionFirstLoadedAudio', 'First question', 'onQuestionFirst')" :id="`questionFirstLoadedAudio`" name="load-audio" type="file" accept=".wav,.mp3">
              <input class="button is-info" type="button" value="Записать с микрофона" @click="openModal('questionFirstId', 'questionFirstAudio', 'questionFirstLoadedAudio', 'First question')">
              <audio v-if="tmp.questionFirstLoadedAudio" :ref="'onQuestionFirst'">
                <source v-bind:src="scenario.parameters.questionFirstAudio">
                Ваш браузер не поддерживает html5 audio. Попробуйте chrome.
              </audio>
              <audio-player v-if="tmp.questionFirstLoadedAudio" :file="scenario.parameters.questionFirstAudio"/>
            </div>
            </p>
          </div>
          <div v-if="scenario.parameters.questionFirstId!=''">
            <p class="control">
              <button class="button is-link delete-button" v-on:click="deleteAudio('questionFirstId', 'questionFirstAudio', 'questionFirstLoadedAudio', 'questionFirstGeneratedAudio')">
                <span class="icon">
                  <i class="fa fa-minus-circle"></i>
                </span>
                <span>Удалить аудио</span>
              </button>
            </p>
          </div>
          <generate-repeat-audio :repeat-data="{ generationState : scenario.parameters.questionFirstRepeatGenerationState, questionAudio: scenario.parameters.questionFirstRepeatAudio, questionText: scenario.parameters.questionFirstRepeatText}" :speaker-List = "speakerList" :emotion-list="emotionList" :state-name="'questionFirst'"/>
        </div>

        <div>
          <span class="second-layer positive-scenario">
            <div>
              <label class="label">Вопрос 2 / Сообщение (При ответе Да на Вопрос 1)  <input v-model="scenario.parameters.questionSecondYesKey" placeholder="Введите ключ вопроса" class="input questionKey"></label>
              <p class="control">
                <input type="radio" v-model="scenario.parameters.questionSecondYesGenerationState"
                       v-bind:value="false"
                       @change="onChangeGenerationState('questionSecondYesGenerationState', 'questionSecondYesAudio', 'questionSecondYesGeneratedAudio', 'questionSecondYesLoadedAudio', 'onQuestionSecondYes')">
                <label>Загрузить аудио</label>
                <br/>
                <input type="radio" v-model="scenario.parameters.questionSecondYesGenerationState"
                      v-bind:value="true"
                      @change="onChangeGenerationState('questionSecondYesGenerationState', 'questionSecondYesAudio', 'questionSecondYesGeneratedAudio', 'questionSecondYesLoadedAudio', 'onQuestionSecondYes')">
                <label>Сгенерировать аудио</label>
              </p>
              <div v-if="scenario.parameters.questionSecondYesGenerationState">
                <p class="control">
                <textarea v-model="scenario.parameters.questionSecondYesText" class="textarea"></textarea>
                <div class="control is-grouped">
                  <button class="button is-primary" v-on:click="genAudio('questionSecondYesId', 'questionSecondYesAudio', 'currentSpeakerSecondYes', 'questionSecondYesGeneratedAudio', 'questionSecondYesText', 'questionSecondYesLoading', 'Second yes question', 'currentEmotionSecondYes', 'currentSpeedSecondYes')">
                    <span class="icon">
                      <i class="fa fa-magic"></i>
                    </span>
                    <div class="loader spinner" v-if="tmp.questionSecondYesLoading"></div>
                    Сгенерировать аудио
                  </button>

                  <div class="select is-primary">
                   <select v-model="tmp.currentSpeakerSecondYes" class="form-control">
                     <option v-for="speaker in speakerList">
                       {{speaker.value}}
                      </option>
                    </select>
                  </div>
                  <div class="select is-primary">
                    <select v-model="tmp.currentEmotionSecondYes" class="form-control">
                      <option v-for="emotion in emotionList">
                        {{emotion.value}}
                      </option>
                    </select>
                  </div>
                  <p>
                    <slider size="small" v-bind:value="tmp.currentSpeedSecondYes" :min="0.1" :step="0.1" :max="3" @change="tmp.currentSpeedSecondYes = $event"></slider>
                    Скорость:&nbsp{{tmp.currentSpeedSecondYes}}
                  </p>

                  <audio v-if="tmp.questionSecondYesGeneratedAudio" :ref="'onQuestionSecondYes'">
                    <source v-bind:src="scenario.parameters.questionSecondYesAudio">
                    Ваш браузер не поддерживает html5 audio. Попробуйте chrome.
                  </audio>
                  <audio-player v-if="tmp.questionSecondYesGeneratedAudio" :file="scenario.parameters.questionSecondYesAudio"/>
                </div>
                </p>
              </div>
              <div v-if="!scenario.parameters.questionSecondYesGenerationState">
                <p class="control">
                <div class="control">
                <input class="button is-info" type="button" value="Загрузить из файла" @click="uploadFile('questionSecondYesLoadedAudio')">
                <input style="display:none;" @input="loadAudio('questionSecondYesLoadedAudio', 'questionSecondYesId', 'questionSecondYesAudio', 'questionSecondYesLoadedAudio', 'Second yes question', 'onQuestionSecondYes')" :id="`questionSecondYesLoadedAudio`" name="load-audio" type="file" accept=".wav,.mp3">
                <input class="button is-info" type="button" value="Записать с микрофона" @click="openModal('questionSecondYesId', 'questionSecondYesAudio', 'questionSecondYesLoadedAudio', 'Second yes question')">
                <audio v-if="tmp.questionSecondYesLoadedAudio" :ref="'onQuestionSecondYes'">
                  <source v-bind:src="scenario.parameters.questionSecondYesAudio">
                 Ваш браузер не поддерживает html5 audio. Попробуйте chrome.
                </audio>
                <audio-player v-if="tmp.questionSecondYesLoadedAudio" :file="scenario.parameters.questionSecondYesAudio"/>
                </div>
                </p>
              </div>
              <div v-if="scenario.parameters.questionSecondYesId!=''">
                <p class="control">
                  <button class="button is-link delete-button" v-on:click="deleteAudio('questionSecondYesId', 'questionSecondYesAudio', 'questionSecondYesLoadedAudio', 'questionSecondYesGeneratedAudio')">
                    <span class="icon">
                      <i class="fa fa-minus-circle"></i>
                    </span>
                    <span>Удалить аудио</span>
                  </button>
                </p>
              </div>
            </div>
            <collapse>
              <collapse-item title="Отправить СМС" class="positive-scenario" :selected="scenario.parameters.questionSecondYesSMSText!=''">
                <p class="control">
                  <textarea v-model="scenario.parameters.questionSecondYesSMSText" class="textarea"></textarea>
                </p>
              </collapse-item>
            </collapse>
            <div class="block is-flex">
            <collapse>
              <collapse-item title="Сообщение при ответе Да на Вопрос 2" class="second-layer positive-scenario" :selected="scenario.parameters.questionSecondYesYesId!=''">
              <div>
              <p class="control">
                <input type="radio" v-model="scenario.parameters.questionSecondYesYesGenerationState"
                       v-bind:value="false"
                       @change="onChangeGenerationState('questionSecondYesYesGenerationState', 'questionSecondYesYesAudio', 'questionSecondYesYesGeneratedAudio', 'questionSecondYesYesLoadedAudio', 'onQuestionSecondYesYes')">
                <label>Загрузить аудио</label>
                <br/>
                <input type="radio" v-model="scenario.parameters.questionSecondYesYesGenerationState"
                      v-bind:value="true"
                      @change="onChangeGenerationState('questionSecondYesYesGenerationState', 'questionSecondYesYesAudio', 'questionSecondYesYesGeneratedAudio', 'questionSecondYesYesLoadedAudio', 'onQuestionSecondYesYes')">
                <label>Сгенерировать аудио</label>
              </p>
              <div v-if="scenario.parameters.questionSecondYesYesGenerationState">
                <p class="control">
                <textarea v-model="scenario.parameters.questionSecondYesYesText" class="textarea"></textarea>
                <div class="control is-grouped">
                  <button class="button is-primary" v-on:click="genAudio('questionSecondYesYesId', 'questionSecondYesYesAudio', 'currentSpeakerSecondYesYes', 'questionSecondYesYesGeneratedAudio', 'questionSecondYesYesText', 'questionSecondYesYesLoading', 'Second yes yes question', 'currentEmotionSecondYesYes', 'currentSpeedSecondYesYes')">
                    <span class="icon">
                      <i class="fa fa-magic"></i>
                    </span>
                    <div class="loader spinner" v-if="tmp.questionSecondYesYesLoading"></div>
                    Сгенерировать аудио
                  </button>

                   <div class="select is-primary">
                     <select v-model="tmp.currentSpeakerSecondYesYes" class="form-control">
                       <option v-for="speaker in speakerList">
                         {{speaker.value}}
                        </option>
                      </select>
                    </div>
                    <div class="select is-primary">
                      <select v-model="tmp.currentEmotionSecondYesYes" class="form-control">
                        <option v-for="emotion in emotionList">
                          {{emotion.value}}
                        </option>
                      </select>
                    </div>
                    <p>
                      <slider size="small" v-bind:value="tmp.currentSpeedSecondYesYes" :min="0.1" :step="0.1" :max="3" @change="tmp.currentSpeedSecondYesYes = $event"></slider>
                      Скорость:&nbsp{{tmp.currentSpeedSecondYesYes}}
                    </p>

                  <audio v-if="tmp.questionSecondYesYesGeneratedAudio" :ref="'onQuestionSecondYesYes'">
                    <source v-bind:src="scenario.parameters.questionSecondYesYesAudio">
                    Ваш браузер не поддерживает html5 audio. Попробуйте chrome.
                  </audio>
                  <audio-player v-if="tmp.questionSecondYesYesGeneratedAudio" :file="scenario.parameters.questionSecondYesYesAudio"/>
                </div>
                </p>
              </div>
              <div v-if="!scenario.parameters.questionSecondYesYesGenerationState">
                <p class="control">
                <div class="control">
                <input class="button is-info" type="button" value="Загрузить из файла" @click="uploadFile('questionSecondYesYesLoadedAudio')">
                <input style="display:none;" @input="loadAudio('questionSecondYesYesLoadedAudio', 'questionSecondYesYesId', 'questionSecondYesYesAudio', 'questionSecondYesYesLoadedAudio', 'Second yes yes question', 'onQuestionSecondYesYes')" :id="`questionSecondYesYesLoadedAudio`" name="load-audio" type="file" accept=".wav,.mp3">
                <input class="button is-info" type="button" value="Записать с микрофона" @click="openModal('questionSecondYesYesId', 'questionSecondYesYesAudio', 'questionSecondYesYesLoadedAudio', 'Second yes yes question')">
                <audio v-if="tmp.questionSecondYesYesLoadedAudio" :ref="'onQuestionSecondYesYes'">
                  <source v-bind:src="scenario.parameters.questionSecondYesYesAudio">
                 Ваш браузер не поддерживает html5 audio. Попробуйте chrome.
                </audio>
                <audio-player v-if="tmp.questionSecondYesYesLoadedAudio" :file="scenario.parameters.questionSecondYesYesAudio"/>
                </div>
                </p>
              </div>
                <div v-if="scenario.parameters.questionSecondYesYesId!=''">
                  <p class="control">
                    <button class="button is-link delete-button" v-on:click="deleteAudio('questionSecondYesYesId', 'questionSecondYesYesAudio', 'questionSecondYesYesLoadedAudio', 'questionSecondYesYesGeneratedAudio')">
                      <span class="icon">
                        <i class="fa fa-minus-circle"></i>
                      </span>
                      <span>Удалить аудио</span>
                    </button>
                  </p>
                </div>
              </div>
              <collapse>
                <collapse-item title="Отправить СМС" class="positive-scenario" :selected="scenario.parameters.questionSecondYesYesSMSText!=''">
                  <p class="control">
                    <textarea v-model="scenario.parameters.questionSecondYesYesSMSText" class="textarea"></textarea>
                  </p>
                </collapse-item>
              </collapse>
            </collapse-item>
              <collapse-item title="Сообщение при ответе Нет на Вопрос 2" class="second-layer negative-scenario" :selected="scenario.parameters.questionSecondYesNoId!=''">
              <div>
              <p class="control">
                <input type="radio" v-model="scenario.parameters.questionSecondYesNoGenerationState"
                       v-bind:value="false"
                       @change="onChangeGenerationState('questionSecondYesNoGenerationState', 'questionSecondYesNoAudio', 'questionSecondYesNoGeneratedAudio', 'questionSecondYesNoLoadedAudio', 'onQuestionSecondYesNo')">
                <label>Загрузить аудио</label>
                <br/>
                <input type="radio" v-model="scenario.parameters.questionSecondYesNoGenerationState"
                      v-bind:value="true"
                      @change="onChangeGenerationState('questionSecondYesNoGenerationState', 'questionSecondYesNoAudio', 'questionSecondYesNoGeneratedAudio', 'questionSecondYesNoLoadedAudio', 'onQuestionSecondYesNo')">
                <label>Сгенерировать аудио</label>
              </p>
              <div v-if="scenario.parameters.questionSecondYesNoGenerationState">
                <p class="control">
                <textarea v-model="scenario.parameters.questionSecondYesNoText" class="textarea"></textarea>
                <div class="control is-grouped">
                  <button class="button is-primary" v-on:click="genAudio('questionSecondYesNoId', 'questionSecondYesNoAudio', 'currentSpeakerSecondYesNo', 'questionSecondYesNoGeneratedAudio', 'questionSecondYesNoText', 'questionSecondYesNoLoading', 'Second yes no question', 'currentEmotionSecondYesNo', 'currentSpeedSecondYesNo')">
                    <span class="icon">
                      <i class="fa fa-magic"></i>
                    </span>
                    <div class="loader spinner" v-if="tmp.questionSecondYesNoLoading"></div>
                    Сгенерировать аудио
                  </button>

                  <div class="select is-primary">
                    <select v-model="tmp.currentSpeakerSecondYesNo" class="form-control">
                      <option v-for="speaker in speakerList">
                        {{speaker.value}}
                      </option>
                    </select>
                  </div>
                  <div class="select is-primary">
                    <select v-model="tmp.currentEmotionSecondYesNo" class="form-control">
                      <option v-for="emotion in emotionList">
                        {{emotion.value}}
                      </option>
                    </select>
                  </div>
                  <p>
                    <slider size="small" v-bind:value="tmp.currentSpeedSecondYesNo" :min="0.1" :step="0.1" :max="3" @change="tmp.currentSpeedSecondYesNo = $event"></slider>
                    Скорость:&nbsp{{tmp.currentSpeedSecondYesNo}}
                  </p>

                  <audio v-if="tmp.questionSecondYesNoGeneratedAudio" :ref="'onQuestionSecondYesNo'">
                    <source v-bind:src="scenario.parameters.questionSecondYesNoAudio">
                    Ваш браузер не поддерживает html5 audio. Попробуйте chrome.
                  </audio>
                  <audio-player v-if="tmp.questionSecondYesNoGeneratedAudio" :file="scenario.parameters.questionSecondYesNoAudio"/>
                </div>
                </p>
              </div>
              <div v-if="!scenario.parameters.questionSecondYesNoGenerationState">
                <p class="control">
                <div class="control">
                <input class="button is-info" type="button" value="Загрузить из файла" @click="uploadFile('questionSecondYesNoLoadedAudio')">
                <input style="display:none;" @input="loadAudio('questionSecondYesNoLoadedAudio', 'questionSecondYesNoId', 'questionSecondYesNoAudio', 'questionSecondYesNoLoadedAudio', 'Second yes no question', 'onQuestionSecondYesNo')" :id="`questionSecondYesNoLoadedAudio`" name="load-audio" type="file" accept=".wav,.mp3">
                <input class="button is-info" type="button" value="Записать с микрофона" @click="openModal('questionSecondYesNoId', 'questionSecondYesNoAudio', 'questionSecondYesNoLoadedAudio', 'Second yes no question')">
                <audio v-if="tmp.questionSecondYesNoLoadedAudio" :ref="'onQuestionSecondYesNo'">
                  <source v-bind:src="scenario.parameters.questionSecondYesNoAudio">
                 Ваш браузер не поддерживает html5 audio. Попробуйте chrome.
                </audio>
                <audio-player v-if="tmp.questionSecondYesNoLoadedAudio" :file="scenario.parameters.questionSecondYesNoAudio"/>
                </div>
                </p>
              </div>
                <div v-if="scenario.parameters.questionSecondYesNoId!=''">
                  <p class="control">
                    <button class="button is-link delete-button" v-on:click="deleteAudio('questionSecondYesNoId', 'questionSecondYesNoAudio', 'questionSecondYesNoLoadedAudio', 'questionSecondYesNoGeneratedAudio')">
                      <span class="icon">
                        <i class="fa fa-minus-circle"></i>
                      </span>
                      <span>Удалить аудио</span>
                    </button>
                  </p>
                </div>
              </div>
            </collapse-item>
            </collapse>
            </div>
          </span>
        </div>

        <p style="padding: 10px;"></p>

    <div>
          <span class="second-layer negative-scenario">
            <div>
              <label class="label">Вопрос 2 / Сообщение (При ответе Нет на Вопрос 1) <input v-model="scenario.parameters.questionSecondNoKey" placeholder="Введите ключ вопроса" class="input questionKey"></label>
              <p class="control">
                <input type="radio" v-model="scenario.parameters.questionSecondNoGenerationState"
                       v-bind:value="false"
                       @change="onChangeGenerationState('questionSecondNoGenerationState', 'questionSecondNoAudio', 'questionSecondNoGeneratedAudio', 'questionSecondNoLoadedAudio', 'onQuestionSecondNo')">
                <label>Загрузить аудио</label>
                <br/>
                <input type="radio" v-model="scenario.parameters.questionSecondNoGenerationState"
                      v-bind:value="true"
                      @change="onChangeGenerationState('questionSecondNoGenerationState', 'questionSecondNoAudio', 'questionSecondNoGeneratedAudio', 'questionSecondNoLoadedAudio', 'onQuestionSecondNo')">
                <label>Сгенерировать аудио</label>
              </p>
              <div v-if="scenario.parameters.questionSecondNoGenerationState">
                <p class="control">
                <textarea v-model="scenario.parameters.questionSecondNoText" class="textarea"></textarea>
                <div class="control is-grouped">
                  <button class="button is-primary" v-on:click="genAudio('questionSecondNoId', 'questionSecondNoAudio', 'currentSpeakerSecondNo', 'questionSecondNoGeneratedAudio', 'questionSecondNoText', 'questionSecondNoLoading', 'Second no question', 'currentEmotionSecondNo', 'currentSpeedSecondNo')">
                    <span class="icon">
                      <i class="fa fa-magic"></i>
                    </span>
                    <div class="loader spinner" v-if="tmp.questionSecondNoLoading"></div>
                    Сгенерировать аудио
                  </button>

                  <div class="select is-primary">
                    <select v-model="tmp.currentSpeakerSecondNo" class="form-control">
                      <option v-for="speaker in speakerList">
                        {{speaker.value}}
                      </option>
                    </select>
                  </div>
                  <div class="select is-primary">
                    <select v-model="tmp.currentEmotionSecondNo" class="form-control">
                      <option v-for="emotion in emotionList">
                        {{emotion.value}}
                      </option>
                    </select>
                  </div>
                  <p>
                    <slider size="small" v-bind:value="tmp.currentSpeedSecondNo" :min="0.1" :step="0.1" :max="3" @change="tmp.currentSpeedSecondNo = $event"></slider>
                    Скорость:&nbsp{{tmp.currentSpeedSecondNo}}
                  </p>

                  <audio v-if="tmp.questionSecondNoGeneratedAudio" :ref="'onQuestionSecondNo'">
                    <source v-bind:src="scenario.parameters.questionSecondNoAudio">
                    Ваш браузер не поддерживает html5 audio. Попробуйте chrome.
                  </audio>
                  <audio-player v-if="tmp.questionSecondNoGeneratedAudio" :file="scenario.parameters.questionSecondNoAudio"/>
                </div>
                </p>
              </div>
              <div v-if="!scenario.parameters.questionSecondNoGenerationState">
                <p class="control">
                <div class="control">
                <input class="button is-info" type="button" value="Загрузить из файла" @click="uploadFile('questionSecondNoLoadedAudio')">
                <input style="display:none;" @input="loadAudio('questionSecondNoLoadedAudio', 'questionSecondNoId', 'questionSecondNoAudio', 'questionSecondNoLoadedAudio', 'Second no question', 'onQuestionSecondNo')" :id="`questionSecondNoLoadedAudio`" name="load-audio" type="file" accept=".wav,.mp3">
                <input class="button is-info" type="button" value="Записать с микрофона" @click="openModal('questionSecondNoId', 'questionSecondNoAudio', 'questionSecondNoLoadedAudio', 'Second no question')">
                <audio v-if="tmp.questionSecondNoLoadedAudio" :ref="'onQuestionSecondNo'">
                  <source v-bind:src="scenario.parameters.questionSecondNoAudio">
                 Ваш браузер не поддерживает html5 audio. Попробуйте chrome.
                </audio>
                <audio-player v-if="tmp.questionSecondNoLoadedAudio" :file="scenario.parameters.questionSecondNoAudio"/>
                </div>
                </p>
              </div>
              <div v-if="scenario.parameters.questionSecondNoId!=''">
                <p class="control">
                  <button class="button is-link delete-button" v-on:click="deleteAudio('questionSecondNoId', 'questionSecondNoAudio', 'questionSecondNoLoadedAudio', 'questionSecondNoGeneratedAudio')">
                    <span class="icon">
                      <i class="fa fa-minus-circle"></i>
                    </span>
                    <span>Удалить аудио</span>
                  </button>
                </p>
              </div>
            </div>

            <div class="block is-flex">
            <collapse>
              <collapse-item title="Сообщение при ответе Да на Вопрос 2" class="second-layer positive-scenario" :selected="scenario.parameters.questionSecondNoYesId!=''">
              <div>
              <p class="control">
                <input type="radio" v-model="scenario.parameters.questionSecondNoYesGenerationState"
                       v-bind:value="false"
                       @change="onChangeGenerationState('questionSecondNoYesGenerationState', 'questionSecondNoYesAudio', 'questionSecondNoYesGeneratedAudio', 'questionSecondNoYesLoadedAudio', 'onQuestionSecondNoYes')">
                <label>Загрузить аудио</label>
                <br/>
                <input type="radio" v-model="scenario.parameters.questionSecondNoYesGenerationState"
                       v-bind:value="true"
                       @change="onChangeGenerationState('questionSecondNoYesGenerationState', 'questionSecondNoYesAudio', 'questionSecondNoYesGeneratedAudio', 'questionSecondNoYesLoadedAudio', 'onQuestionSecondNoYes')">
                <label>Сгенерировать аудио</label>
              </p>
              <div v-if="scenario.parameters.questionSecondNoYesGenerationState">
                <p class="control">
                <textarea v-model="scenario.parameters.questionSecondNoYesText" class="textarea"></textarea>
                <div class="control is-grouped">
                  <button class="button is-primary" v-on:click="genAudio('questionSecondNoYesId', 'questionSecondNoYesAudio', 'currentSpeakerSecondNoYes', 'questionSecondNoYesGeneratedAudio', 'questionSecondNoYesText', 'questionSecondNoYesLoading', 'Second no yes question', 'currentEmotionSecondNoYes', 'currentSpeedSecondNoYes')">
                    <span class="icon">
                      <i class="fa fa-magic"></i>
                    </span>
                    <div class="loader spinner" v-if="tmp.questionSecondNoYesLoading"></div>
                    Сгенерировать аудио
                  </button>

                  <div class="select is-primary">
                    <select v-model="tmp.currentSpeakerSecondNoYes" class="form-control">
                      <option v-for="speaker in speakerList">
                        {{speaker.value}}
                      </option>
                    </select>
                  </div>
                  <div class="select is-primary">
                    <select v-model="tmp.currentEmotionSecondNoYes" class="form-control">
                      <option v-for="emotion in emotionList">
                        {{emotion.value}}
                      </option>
                    </select>
                  </div>
                  <p>
                    <slider size="small" v-bind:value="tmp.currentSpeedSecondNoYes" :min="0.1" :step="0.1" :max="3" @change="tmp.currentSpeedSecondNoYes = $event"></slider>
                    Скорость:&nbsp{{tmp.currentSpeedSecondNoYes}}
                  </p>

                  <audio v-if="tmp.questionSecondNoYesGeneratedAudio" :ref="'onQuestionSecondNoYes'">
                    <source v-bind:src="scenario.parameters.questionSecondNoYesAudio">
                    Ваш браузер не поддерживает html5 audio. Попробуйте chrome.
                  </audio>
                  <audio-player v-if="tmp.questionSecondNoYesGeneratedAudio" :file="scenario.parameters.questionSecondNoYesAudio"/>
                </div>
                </p>
              </div>
              <div v-if="!scenario.parameters.questionSecondNoYesGenerationState">
                <p class="control">
                <div class="control">
                <input class="button is-info" type="button" value="Загрузить из файла" @click="uploadFile('questionSecondNoYesLoadedAudio')">
                <input style="display:none;" @input="loadAudio('questionSecondNoYesLoadedAudio', 'questionSecondNoYesId', 'questionSecondNoYesAudio', 'questionSecondNoYesLoadedAudio', 'Second no yes question', 'onQuestionSecondNoYes')" :id="`questionSecondNoYesLoadedAudio`" name="load-audio" type="file" accept=".wav,.mp3">
                <input class="button is-info" type="button" value="Записать с микрофона" @click="openModal('questionSecondNoYesId', 'questionSecondNoYesAudio', 'questionSecondNoYesLoadedAudio', 'Second no yes question')">
                <audio v-if="tmp.questionSecondNoYesLoadedAudio" :ref="'onQuestionSecondNoYes'">
                  <source v-bind:src="scenario.parameters.questionSecondNoYesAudio">
                 Ваш браузер не поддерживает html5 audio. Попробуйте chrome.
                </audio>
                <audio-player v-if="tmp.questionSecondNoYesLoadedAudio" :file="scenario.parameters.questionSecondNoYesAudio"/>
                </div>
                </p>
              </div>
                <div v-if="scenario.parameters.questionSecondNoYesId!=''">
                  <p class="control">
                    <button class="button is-link delete-button" v-on:click="deleteAudio('questionSecondNoYesId', 'questionSecondNoYesAudio', 'questionSecondNoYesLoadedAudio', 'questionSecondNoYesGeneratedAudio')">
                      <span class="icon">
                        <i class="fa fa-minus-circle"></i>
                      </span>
                      <span>Удалить аудио</span>
                    </button>
                  </p>
                </div>
              </div>


              </collapse-item>
              <collapse-item title="Сообщение при ответе Нет на Вопрос 2" class="second-layer negative-scenario" :selected="scenario.parameters.questionSecondNoNoId!=''">
              <div>
              <p class="control">
                <input type="radio" v-model="scenario.parameters.questionSecondNoNoGenerationState"
                       v-bind:value="false"
                       @change="onChangeGenerationState('questionSecondNoNoGenerationState', 'questionSecondNoNoAudio', 'questionSecondNoNoGeneratedAudio', 'questionSecondNoNoLoadedAudio', 'onQuestionSecondNoNo')">
                <label>Загрузить аудио</label>
                <br/>
                <input type="radio" v-model="scenario.parameters.questionSecondNoNoGenerationState"
                       v-bind:value="true"
                       @change="onChangeGenerationState('questionSecondNoNoGenerationState', 'questionSecondNoNoAudio', 'questionSecondNoNoGeneratedAudio', 'questionSecondNoNoLoadedAudio', 'onQuestionSecondNoNo')">
                <label>Сгенерировать аудио</label>
              </p>
              <div v-if="scenario.parameters.questionSecondNoNoGenerationState">
                <p class="control">
                <textarea v-model="scenario.parameters.questionSecondNoNoText" class="textarea"></textarea>
                <div class="control is-grouped">
                  <button class="button is-primary" v-on:click="genAudio('questionSecondNoNoId', 'questionSecondNoNoAudio', 'currentSpeakerSecondNoNo', 'questionSecondNoNoGeneratedAudio', 'questionSecondNoNoText', 'questionSecondNoNoLoading', 'Second no no question', 'currentEmotionSecondNoNo', 'currentSpeedSecondNoNo')">
                    <span class="icon">
                      <i class="fa fa-magic"></i>
                    </span>
                    <div class="loader spinner" v-if="tmp.questionSecondNoNoLoading"></div>
                    Сгенерировать аудио
                  </button>

                  <div class="select is-primary">
                    <select v-model="tmp.currentSpeakerSecondNoNo" class="form-control">
                      <option v-for="speaker in speakerList">
                        {{speaker.value}}
                      </option>
                    </select>
                  </div>
                  <div class="select is-primary">
                    <select v-model="tmp.currentEmotionSecondNoNo" class="form-control">
                      <option v-for="emotion in emotionList">
                        {{emotion.value}}
                      </option>
                    </select>
                  </div>
                  <p>
                    <slider size="small" v-bind:value="tmp.currentSpeedSecondNoNo" :min="0.1" :step="0.1" :max="3" @change="tmp.currentSpeedSecondNoNo = $event"></slider>
                    Скорость:&nbsp{{tmp.currentSpeedSecondNoNo}}
                  </p>

                  <audio v-if="tmp.questionSecondNoNoGeneratedAudio" :ref="'onQuestionSecondNoNo'">
                    <source v-bind:src="scenario.parameters.questionSecondNoNoAudio">
                    Ваш браузер не поддерживает html5 audio. Попробуйте chrome.
                  </audio>
                  <audio-player v-if="tmp.questionSecondNoNoGeneratedAudio" :file="scenario.parameters.questionSecondNoNoAudio"/>
                </div>
                </p>
              </div>
              <div v-if="!scenario.parameters.questionSecondNoNoGenerationState">
                <p class="control">
                <div class="control">
                <input class="button is-info" type="button" value="Загрузить из файла" @click="uploadFile('questionSecondNoNoLoadedAudio')">
                <input style="display:none;" @input="loadAudio('questionSecondNoNoLoadedAudio', 'questionSecondNoNoId', 'questionSecondNoNoAudio', 'questionSecondNoNoLoadedAudio', 'Second no no question', 'onQuestionSecondNoNo')" :id="`questionSecondNoNoLoadedAudio`" name="load-audio" type="file" accept=".wav,.mp3">
                <input class="button is-info" type="button" value="Записать с микрофона" @click="openModal('questionSecondNoNoId', 'questionSecondNoNoAudio', 'questionSecondNoNoLoadedAudio', 'Second no no question')">
                <audio v-if="tmp.questionSecondNoNoLoadedAudio" :ref="'onQuestionSecondNoNo'">
                  <source v-bind:src="scenario.parameters.questionSecondNoNoAudio">
                 Ваш браузер не поддерживает html5 audio. Попробуйте chrome.
                </audio>
                <audio-player v-if="tmp.questionSecondNoNoLoadedAudio" :file="scenario.parameters.questionSecondNoNoAudio"/>
                </div>
                </p>
              </div>
                <div v-if="scenario.parameters.questionSecondNoNoId!=''">
                  <p class="control">
                    <button class="button is-link delete-button" v-on:click="deleteAudio('questionSecondNoNoId', 'questionSecondNoNoAudio', 'questionSecondNoNoLoadedAudio', 'questionSecondNoNoGeneratedAudio')">
                      <span class="icon">
                        <i class="fa fa-minus-circle"></i>
                      </span>
                      <span>Удалить аудио</span>
                    </button>
                  </p>
                </div>
              </div>

              </collapse-item>
            </collapse>
            </div>
          </span>
    </div>
    <p class="control">
      <button class="button is-primary" v-on:click="save(true)">
        <span class="icon">
          <i class="fa fa-floppy-o"></i>
        </span>
        <span>Сохранить</span>
      </button>
      <button class="button is-light" v-on:click="cancel">
        <span class="icon">
          <i class="fa fa-times-circle"></i>
        </span>
        <span>Закрыть</span>
      </button>
      <button class="button is-primary">
        <span class="icon">
          <i class="fa fa-calculator"></i>
        </span>
        <span>Рассчитать стоимость</span>
      </button>
      <button v-if="scenario.isReady" class="button is-success is-outlined" :disabled="true">
        <span class="icon">
          <i class="fa fa-info"></i>
        </span>
        <span>Подготовлен</span>
      </button>
      <button v-else class="button is-danger is-outlined" :disabled="true">
        <span class="icon">
          <i class="fa fa-info"></i>
        </span>
        <span>Не подготовлен</span>
      </button>
    </p>
    <modal :visible="showModal" :title=title @confirm="confirmAction" @close="closeModal"></modal>
  </div>
</template>

<script>
  import Cleave from 'vue-cleave'
  import AudioPlayer from '../../../components/audio-player.vue'
  import { mapGetters } from 'vuex'
  import Vue from 'vue'
  import Notification from 'vue-bulma-notification'
  import { Collapse, Item as CollapseItem } from 'vue-bulma-collapse'
  import Message from 'vue-bulma-message'
  import Modal from '../ModalAudio'
  import Slider from 'vue-bulma-slider'
  import GenerateRepeatAudio from './GenerateRepeatAudio'

  const NotificationComponent = Vue.extend(Notification)
  const openNotification = (propsData = {
    title: '',
    message: '',
    type: '',
    direction: '',
    duration: 4500,
    container: '.notifications'
  }) => {
    return new NotificationComponent({
      el: document.createElement('div'),
      propsData
    })
  }

  const MessageComponent = Vue.extend(Message)
  const openMessage = (propsData = {
    title: '',
    message: '',
    type: '',
    direction: '',
    duration: 10000,
    container: '.messages'
  }) => {
    return new MessageComponent({
      el: document.createElement('div'),
      propsData
    })
  }

  const api = '/api/scenarios'
  const audioGeneratorApi = '/audios/generate'
  const audioUploadApi = '/audios/reSave'
  const audioDeleteApi = '/audios'
  const PROFILES_API = '/api/profiles'

  export default {
    props: ['name', 'campaignid'],
    components: {
      GenerateRepeatAudio,
      Modal,
      Cleave,
      AudioPlayer,
      Message,
      Notification,
      Collapse,
      CollapseItem,
      Slider
    },
    computed: {
      ...mapGetters([
        'loadedScenario',
        'loggedId',
        'loggedUser',
        'authenticationToken'
      ])
    },
    methods: {
      prepareSecurityHeader() {
        console.log(this.authenticationToken)
        return {
          Authorization: `Bearer ${this.authenticationToken}`
        }
      },
      changeRoute: function(e) {
        this.$router.push({path:'/scenarios' + e.target.value})
      },
      checkAudioDuration() {
        this.scenario.checkDuration = true
        var len = document.querySelectorAll('audio').length
        for (var i = 0; i < len; i++) {
          if (document.querySelectorAll('audio')[i].attributes.getNamedItem('src') != null) {
            this.scenario.checkDuration = this.scenario.checkDuration && (document.querySelectorAll('audio')[i].duration > 0)
          }
        }
        return this.scenario.checkDuration
      },
      save (showMessage) {
        if (this.checkAudioDuration()) {
          if (this.scenario.id === undefined) {
            this.saveNew(showMessage)
          } else {
            this.update(showMessage)
          }
        } else {
          this.openNotificationWithType('danger', 'Нельзя сохранить сценарий с аудиофайлом нулевой длительности')
        }
      },
      saveNew (showMessage) {
        console.log('saving new scenario: ' + JSON.stringify(this.scenario))

        if (!this.scenario.parameters.questionFirstGenerationState) {
          this.scenario.parameters.questionFirstText = ''
        }
        this.scenario.parameters.questionFirstSpeaker = this.tmp.currentSpeakerFirst
        this.scenario.parameters.questionFirstEmotion = this.tmp.currentEmotionFirst
        this.scenario.parameters.questionFirstSpeed = this.tmp.currentSpeedFirst

        if (!this.scenario.parameters.questionSecondYesGenerationState) {
          this.scenario.parameters.questionSecondYesText = ''
        }
        this.scenario.parameters.questionSecondYesSpeaker = this.tmp.currentSpeakerSecondYes
        this.scenario.parameters.questionSecondYesEmotion = this.tmp.currentEmotionSecondYes
        this.scenario.parameters.questionSecondYesSpeed = this.tmp.currentSpeedSecondYes

        if (!this.scenario.parameters.questionSecondYesYesGenerationState) {
          this.scenario.parameters.questionSecondYesYesText = ''
        }
        this.scenario.parameters.questionSecondYesYesSpeaker = this.tmp.currentSpeakerSecondYesYes
        this.scenario.parameters.questionSecondYesYesEmotion = this.tmp.currentEmotionSecondYesYes
        this.scenario.parameters.questionSecondYesYesSpeed = this.tmp.currentSpeedSecondYesYes

        if (!this.scenario.parameters.questionSecondYesNoGenerationState) {
          this.scenario.parameters.questionSecondYesNoText = ''
        }
        this.scenario.parameters.questionSecondYesNoSpeaker = this.tmp.currentSpeakerSecondYesNo
        this.scenario.parameters.questionSecondYesNoEmotion = this.tmp.currentEmotionSecondYesNo
        this.scenario.parameters.questionSecondYesNoSpeed = this.tmp.currentSpeedSecondYesNo

        if (!this.scenario.parameters.questionSecondNoGenerationState) {
          this.scenario.parameters.questionSecondNoText = ''
        }
        this.scenario.parameters.questionSecondNoSpeaker = this.tmp.currentSpeakerSecondNo
        this.scenario.parameters.questionSecondNoEmotion = this.tmp.currentEmotionSecondNo
        this.scenario.parameters.questionSecondNoSpeed = this.tmp.currentSpeedSecondNo

        if (!this.scenario.parameters.questionSecondNoYesGenerationState) {
          this.scenario.parameters.questionSecondNoYesText = ''
        }
        this.scenario.parameters.questionSecondNoYesSpeaker = this.tmp.currentSpeakerSecondNoYes
        this.scenario.parameters.questionSecondNoYesEmotion = this.tmp.currentEmotionSecondNoYes
        this.scenario.parameters.questionSecondNoYesSpeed = this.tmp.currentSpeedSecondNoYes

        if (!this.scenario.parameters.questionSecondNoNoGenerationState) {
          this.scenario.parameters.questionSecondNoNoText = ''
        }
        this.scenario.parameters.questionSecondNoNoSpeaker = this.tmp.currentSpeakerSecondNoNo
        this.scenario.parameters.questionSecondNoNoEmotion = this.tmp.currentEmotionSecondNoNo
        this.scenario.parameters.questionSecondNoNoSpeed = this.tmp.currentSpeedSecondNoNo

        this.scenario.parameters.questionSecondYesYesOptional = true
        this.scenario.parameters.questionSecondYesNoOptional = true
        this.scenario.parameters.questionSecondNoYesOptional = true
        this.scenario.parameters.questionSecondNoNoOptional = true

        this.$http.post(api, this.scenario, {headers: this.prepareSecurityHeader()})
          .then((response) => {
            this.isSaved = true
            if (showMessage) {
              this.openNotificationWithType('info', 'Сценарий сохранен')
              this.$emit('set', this.scenario)
            }
        this.scenario = response.data
      }).catch((error) => {
          console.log(error)
          this.openNotificationWithType('danger', 'Ошибка сохранения сценария. ')
      })
      },
      update (showMessage) {
        this.scenario.parameters.questionSecondYesYesOptional = true
        this.scenario.parameters.questionSecondYesNoOptional = true
        this.scenario.parameters.questionSecondNoYesOptional = true
        this.scenario.parameters.questionSecondNoNoOptional = true

          this.scenario.parameters.questionFirstSpeaker = this.tmp.currentSpeakerFirst
          this.scenario.parameters.questionFirstEmotion = this.tmp.currentEmotionFirst
          this.scenario.parameters.questionFirstSpeed = this.tmp.currentSpeedFirst

          this.scenario.parameters.questionSecondYesSpeaker = this.tmp.currentSpeakerSecondYes
          this.scenario.parameters.questionSecondYesEmotion = this.tmp.currentEmotionSecondYes
          this.scenario.parameters.questionSecondYesSpeed = this.tmp.currentSpeedSecondYes

          this.scenario.parameters.questionSecondYesYesSpeaker = this.tmp.currentSpeakerSecondYesYes
          this.scenario.parameters.questionSecondYesYesEmotion = this.tmp.currentEmotionSecondYesYes
          this.scenario.parameters.questionSecondYesYesSpeed = this.tmp.currentSpeedSecondYesYes

          this.scenario.parameters.questionSecondYesNoSpeaker = this.tmp.currentSpeakerSecondYesNo
          this.scenario.parameters.questionSecondYesNoEmotion = this.tmp.currentEmotionSecondYesNo
          this.scenario.parameters.questionSecondYesNoSpeed = this.tmp.currentSpeedSecondYesNo

          this.scenario.parameters.questionSecondNoSpeaker = this.tmp.currentSpeakerSecondNo
          this.scenario.parameters.questionSecondNoEmotion = this.tmp.currentEmotionSecondNo
          this.scenario.parameters.questionSecondNoSpeed = this.tmp.currentSpeedSecondNo

          this.scenario.parameters.questionSecondNoYesSpeaker = this.tmp.currentSpeakerSecondNoYes
          this.scenario.parameters.questionSecondNoYesEmotion = this.tmp.currentEmotionSecondNoYes
          this.scenario.parameters.questionSecondNoYesSpeed = this.tmp.currentSpeedSecondNoYes

          this.scenario.parameters.questionSecondNoNoSpeaker = this.tmp.currentSpeakerSecondNoNo
          this.scenario.parameters.questionSecondNoNoEmotion = this.tmp.currentEmotionSecondNoNo
          this.scenario.parameters.questionSecondNoNoSpeed = this.tmp.currentSpeedSecondNoNo

        console.log('updating scenario: ' + JSON.stringify(this.scenario))
        this.$http.put(api, this.scenario, {headers: this.prepareSecurityHeader()})
          .then((response) => {
            this.isSaved = true
            this.scenario = response.data
            if (showMessage) {
              this.openNotificationWithType('info', 'Сценарий сохранен')
            }
      }).catch((error) => {
          console.log(error)
          this.openNotificationWithType('danger', 'Ошибка сохранения сценария. ')
      })
      },
      uploadFile(buttonId) {
        if (!this.isSaved) {
          this.openNotificationWithType('danger', 'Перед загрузкой файла необходимо сохранить сценарий')
        } else {
          document.getElementById(buttonId).click()
        }
      },
      genAudioRequest (maybeId, audioName, text, speaker, emotion, speed) {
        var request = {
          'client': this.scenario.client,
          'scenario': this.scenario.id,
          'audioName': audioName,
          'generator': 'yandex',
          'text': text,
          'parameters': {
            'speaker': speaker,
            'emotion': emotion,
            'speed': speed,
            'text': text
          }
        }
        // if audio already generated, request must contain id, so backend will overwrite existing audio
        if (maybeId) {
          request.id = maybeId
        }
        return request
      },
      securityHeaders () {
        return {'testH': 'testHV', 'Authorization': 'Bearer eyJhbGciOiJIUzUxMiJ9.eyJzdWIiOiJBdWRpb0dlbiJ9.qvTNenonHsJkYSNclO8SX0AQ3BIWmiZyQDL7PrnThzXJOmlxNZRuln10_LnL78E90wreiXADVimVa4CKSEI6BQ'}
      },
      onChangeGenerationState(stateId, audioId, generatedAudioId, loadedAudioId, playerId) {
        if (this.scenario.parameters[stateId]) {
          this.scenario.parameters[audioId] = this.tmp[generatedAudioId]
          this.$refs[playerId][0].load()
        } else if (!this.tmp[stateId]) {
          this.scenario.parameters[audioId] = this.tmp[loadedAudioId]
          this.$refs[playerId][0].load()
        }
      },
      genAudio(id, audio, speaker, generatedAudio, text, loadingStatus, name, emotion, speed) {
        const request = this.genAudioRequest(this.scenario.parameters[id], name, this.scenario.parameters[text], this.tmp[speaker], this.tmp[emotion], this.tmp[speed])
        const headers = {headers: this.securityHeaders()}
        if (!this.isSaved) {
          this.openNotificationWithType('danger', 'Перед генерацией аудио необходимо сохранить сценарий')
        } else {
          this.tmp[loadingStatus] = true
          this.$http.post(audioGeneratorApi, request, headers)
            .then(response => {
              this.handleGenRequest(id, audio, generatedAudio, response.data)
              this.tmp[loadingStatus] = false
            })
            .catch(error => {
              console.log(error)
              this.openNotificationWithType('danger', 'Ошибка загрузки аудио. ')
              this.tmp[loadingStatus] = false
            })
        }
      },
      handleGenRequest (id, audio, generatedAudio, data) {
        this.scenario.parameters[id] = data
        this.tmp[generatedAudio] = `/audios/${data}.wav`
        this.scenario.parameters[audio] = this.tmp[generatedAudio]
      },
      loadAudio(inputId, audioId, audioValue, generationType, audioName, player) {
        const input = document.querySelector(`#${inputId}`)
        if (input.files && input.files[0]) {
          if (!this.isSaved) {
            this.openNotificationWithType('danger', 'Перед загрузкой аудио необходимо сохранить сценарий')
          } else {
            this.handleUploadRequest(audioId, audioValue, generationType, input.files[0], audioName)
            this.$refs[player].load()
          }
        }
      },
      handleUploadRequest (audioId, audioValue, generationType, audioFile, audioName) {
        this.$http.post(audioUploadApi, this.prepareMultipartAudio(audioFile, audioId, audioName, this.scenario.client, this.scenario.id), this.prepareUploadHeaders())
          .then(response => {
            this.setAudioValue(audioId, generationType, audioValue, response)
          })
          .catch(error => {
            console.log(error)
            this.openNotificationWithType('danger', 'Ошибка загрузки аудио. ')
          })
      },
      deleteAudio(audioId, audioValue, generationType1, generationType2) {
        this.$http.delete(`${audioDeleteApi}/${this.scenario.parameters[audioId]}`, {headers: this.prepareUploadHeaders()})
          .then((response) => {
            this.deleteAudioValue(audioId, generationType1, generationType2, audioValue)
          })
          .catch((error) => {
            console.log(error)
            this.openNotificationWithType('danger', 'Ошибка удаления аудио. ')
          })
      },
      prepareMultipartAudio (audioFile, audioId, audioName, audioClient, audioScenario) {
        const audioFormData = new FormData()
        audioFormData.append('file', audioFile)
        audioFormData.append('name', audioName)
        audioFormData.append('client', audioClient)
        audioFormData.append('scenario', audioScenario)
        audioFormData.append('id', this.scenario.parameters[audioId])
        return audioFormData
      },
      prepareUploadHeaders () {
        return {
          'headers': {
            'Authorization': 'Bearer eyJhbGciOiJIUzUxMiJ9.eyJzdWIiOiJBdWRpb0dlbiJ9.qvTNenonHsJkYSNclO8SX0AQ3BIWmiZyQDL7PrnThzXJOmlxNZRuln10_LnL78E90wreiXADVimVa4CKSEI6BQ',
            'Content-Type': 'multipart/form-data',
            'testH': 'testHV'
          }
        }
      },
      setAudioValue (audioId, generationType, audioValue, response) {
        this.scenario.parameters[audioId] = response.data
        this.tmp[generationType] = `/audios/${this.scenario.parameters[audioId]}.wav`
        this.scenario.parameters[audioValue] = this.tmp[generationType]
      },
      deleteAudioValue (audioId, generationType1, generationType2, audioValue) {
        this.scenario.parameters[audioId] = ''
        this.tmp[generationType1] = ''
        this.tmp[generationType2] = ''
        this.scenario.parameters[audioValue] = ''
      },
      load () {
        this.$http({
          url: api + '/' + this.name,
          headers: this.prepareSecurityHeader()
        }).then((response) => {
          console.log('opening scenario ' + JSON.stringify(response.data))
          this.isSaved = true
        this.scenario = response.data
        this.question_first_audio = '/audios/' + this.scenario.parameters.questionFirstId + '.wav'
        this.question_second_yes_audio = '/audios/' + this.scenario.parameters.questionSecondYesId + '.wav'
        this.question_second_yes_yes_audio = '/audios/' + this.scenario.parameters.questionSecondYesYesId + '.wav'
        this.question_second_yes_no_audio = '/audios/' + this.scenario.parameters.questionSecondYesNoId + '.wav'
        this.question_second_no_audio = '/audios/' + this.scenario.parameters.questionSecondNoId + '.wav'
        this.question_second_no_yes_audio = '/audios/' + this.scenario.parameters.questionSecondNoYesId + '.wav'
        this.question_second_no_no_audio = '/audios/' + this.scenario.parameters.questionSecondNoNoId + '.wav'
      }).catch((error) => {
          console.log(error)
          this.openNotificationWithType('danger', 'Ошибка загрузки сценария. ')
      })
      },
      cancel () {
        if (this.$props.campaignid == 0) {
          this.$router.push('/scenarios/')
        } else {
          this.$router.push('/campaigns/' + this.$props.campaignid)
        }
      },
      closeModal () {
        this.showModal = false
        this.currentAudio = null
      },
      openModal (audioId, audioValue, generationType, audioName) {
        if (!this.isSaved) {
          this.openNotificationWithType('danger', 'Перед записью аудио необходимо сохранить сценарий')
        } else {
          this.showModal = true
          this.currentAudio = new FormData()
          this.currentAudio.append('audioId', audioId)
          this.currentAudio.append('audioValue', audioValue)
          this.currentAudio.append('generationType', generationType)
          this.currentAudio.append('audioName', audioName)
        }
      },
      confirmAction (value) {
        this.handleUploadRequest(this.currentAudio.get('audioId'), this.currentAudio.get('audioValue'), this.currentAudio.get('generationType'), value.blob, this.currentAudio.get('audioName'))
        this.closeModal()
      },
      notSaved () {
        this.isSaved = false
      },
      loadState () {
        this.$http({
          url: PROFILES_API + '/activeState/' + this.loggedId,
          headers: this.prepareSecurityHeader()
        }).then((response) => {
          this.isActive = response.data
          if (!this.isActive) {
            openMessage({
              message: 'Ваша учетная запись не активна. Создание, редактирование и сохранение сценариев и рассылок невозможно',
              type: 'danger',
              showCloseButton: true
            })
          }
        }).catch((error) => {
          console.log(error)
          this.openNotificationWithType('danger', this.$i18n.messages[this.$i18n.locale].scenarios.errorToGetUserStatus)
        })
      },
      openNotificationWithType (type, message) {
        openNotification({
          title: this.$i18n.messages[this.$i18n.locale].notifications.notification,
          message: message,
          type: type
        })
      }
    },
    data () {
      return {
        scenario: {
          template: 'yesnotwoquestions',
          parameters: {
            questionFirstId: '',
            questionFirstAudio: '',
            questionFirstText: '',
            questionFirstGenerationState: true,
            questionFirstSpeaker: 'oksana',
            questionFirstEmotion: 'neutral',
            questionFirstSpeed: 1,
            questionFirstKey: '',

            questionFirstRepeatGenerationState: 'text',
            questionFirstRepeatAudio: '',
            questionFirstRepeatText: '',
            questionFirstRepeatSpeaker: 'oksana',
            questionFirstRepeatEmotion: 'neutral',
            questionFirstRepeatSpeed: 1,

            questionSecondYesId: '',
            questionSecondYesAudio: '',
            questionSecondYesText: '',
            questionSecondYesGenerationState: true,
            questionSecondYesSMSText: '',
            questionSecondYesSpeaker: 'oksana',
            questionSecondYesEmotion: 'neutral',
            questionSecondYesSpeed: 1,
            questionSecondYesKey: '',

            questionSecondYesYesId: '',
            questionSecondYesYesAudio: '',
            questionSecondYesYesText: '',
            questionSecondYesYesOptional: true,
            questionSecondYesYesGenerationState: true,
            questionSecondYesYesSMSText: '',
            questionSecondYesYesSpeaker: 'oksana',
            questionSecondYesYesEmotion: 'neutral',
            questionSecondYesYesSpeed: 1,

            questionSecondYesNoId: '',
            questionSecondYesNoAudio: '',
            questionSecondYesNoText: '',
            questionSecondYesNoOptional: true,
            questionSecondYesNoGenerationState: true,
            questionSecondYesNoSpeaker: 'oksana',
            questionSecondYesNoEmotion: 'neutral',
            questionSecondYesNoSpeed: 1,

            questionSecondNoId: '',
            questionSecondNoAudio: '',
            questionSecondNoText: '',
            questionSecondNoGenerationState: true,
            questionSecondNoSpeaker: 'oksana',
            questionSecondNoEmotion: 'neutral',
            questionSecondNoSpeed: 1,
              questionSecondNoKey: '',

            questionSecondNoYesId: '',
            questionSecondNoYesAudio: '',
            questionSecondNoYesText: '',
            questionSecondNoYesOptional: true,
            questionSecondNoYesGenerationState: true,
            questionSecondNoYesSpeaker: 'oksana',
            questionSecondNoYesEmotion: 'neutral',
            questionSecondNoYesSpeed: 1,

            questionSecondNoNoId: '',
            questionSecondNoNoAudio: '',
            questionSecondNoNoText: '',
            questionSecondNoNoOptional: true,
            questionSecondNoNoGenerationState: true,
            questionSecondNoNoSpeaker: 'oksana',
            questionSecondNoNoEmotion: 'neutral',
            questionSecondNoNoSpeed: 1
          },
          checkDuration: true
        },
        tmp: {
          questionFirstGeneratedAudio: '',
          questionFirstLoadedAudio: '',
          questionFirstLoading: false,
          currentSpeakerFirst: 'oksana',
          currentEmotionFirst: 'neutral',
          currentSpeedFirst: 1,

          questionSecondYesGeneratedAudio: '',
          questionSecondYesLoadedAudio: '',
          questionSecondYesLoading: false,
          currentSpeakerSecondYes: 'oksana',
          currentEmotionSecondYes: 'neutral',
          currentSpeedSecondYes: 1,

          questionSecondYesYesGeneratedAudio: '',
          questionSecondYesYesLoadedAudio: '',
          questionSecondYesYesLoading: false,
          currentSpeakerSecondYesYes: 'oksana',
          currentEmotionSecondYesYes: 'neutral',
          currentSpeedSecondYesYes: 1,

          questionSecondYesNoGeneratedAudio: '',
          questionSecondYesNoLoadedAudio: '',
          questionSecondYesNoLoading: false,
          currentSpeakerSecondYesNo: 'oksana',
          currentEmotionSecondYesNo: 'neutral',
          currentSpeedSecondYesNo: 1,

          questionSecondNoGeneratedAudio: '',
          questionSecondNoLoadedAudio: '',
          questionSecondNoLoading: false,
          currentSpeakerSecondNo: 'oksana',
          currentEmotionSecondNo: 'neutral',
          currentSpeedSecondNo: 1,

          questionSecondNoYesGeneratedAudio: '',
          questionSecondNoYesLoadedAudio: '',
          questionSecondNoYesLoading: false,
          currentSpeakerSecondNoYes: 'oksana',
          currentEmotionSecondNoYes: 'neutral',
          currentSpeedSecondNoYes: 1,

          questionSecondNoNoGeneratedAudio: '',
          questionSecondNoNoLoadedAudio: '',
          questionSecondNoNoLoading: false,
          currentSpeakerSecondNoNo: 'oksana',
          currentEmotionSecondNoNo: 'neutral',
          currentSpeedSecondNoNo: 1
        },
        speakerList: [
          {
            value: 'jane'
          },
          {
            value: 'oksana'
          },
          {
            value: 'alyss '
          },
          {
            value: 'omazh'
          },
          {
            value: 'zahar '
          },
          {
            value: 'ermil '
          }
        ],
        currentEmotion: 'neutral',
        emotionList: [
          {
            value: 'good'
          },
          {
            value: 'neutral'
          },
          {
            value: 'evil'
          }
        ],
        currentSpeed: 1,
        question_first_audio: '',
        question_second_yes_audio: '',
        question_second_yes_yes_audio: '',
        question_second_yes_no_audio: '',
        question_second_no_audio: '',
        question_second_no_yes_audio: '',
        question_second_no_no_audio: '',
        isSaved: false,
        isActive: false,
        showModal: null,
        title: '',
        currentAudio: null
      }
    },
    created: function () {
      this.loadState()
      if (this.name === undefined) {
        console.log('creating new scenario')
        this.notSaved()
      } else {
        console.log('loading scenario: ' + this.name)
        this.load()
      }
      this.$watch('scenario.parameters.questionFirstAudio', function () {
        this.$refs.onQuestionFirst.load()
      })
      this.$watch('scenario.parameters.questionSecondYesAudio', function () {
        this.$refs.onQuestionSecondYes.load()
      })
      this.$watch('scenario.parameters.questionSecondYesYesAudio', function () {
        this.$refs.onQuestionSecondYesYes.load()
      })
      this.$watch('scenario.parameters.questionSecondYesNoAudio', function () {
        this.$refs.onQuestionSecondYesNo.load()
      })
      this.$watch('scenario.parameters.questionSecondNoAudio', function () {
        this.$refs.onQuestionSecondNo.load()
      })
      this.$watch('scenario.parameters.questionSecondNoYesAudio', function () {
        this.$refs.onQuestionSecondNoYes.load()
      })
      this.$watch('scenario.parameters.questionSecondNoNoAudio', function () {
        this.$refs.onQuestionSecondNoNo.load()
      })

      if (this.loadedScenario) {
        this.isSaved = true
        if (this.scenario.isReady) {
          this.isReady = this.scenario.isReady
          this.scenario = this.loadedScenario
          this.scenario.isReady = this.isReady
        } else {
          this.scenario = this.loadedScenario
        }

        if (this.scenario.parameters.questionFirstGenerationState) {
          this.tmp.questionFirstGeneratedAudio = this.scenario.parameters.questionFirstAudio
        } else {
          this.tmp.questionFirstLoadedAudio = this.scenario.parameters.questionFirstAudio
        }
        this.tmp.currentSpeakerFirst = this.scenario.parameters.questionFirstSpeaker || this.tmp.currentSpeakerFirst
        this.tmp.currentEmotionFirst = this.scenario.parameters.questionFirstEmotion || this.tmp.currentEmotionFirst
        this.tmp.currentSpeedFirst = this.scenario.parameters.questionFirstSpeed || this.tmp.currentSpeedFirst

        if (this.scenario.parameters.questionSecondYesGenerationState) {
          this.tmp.questionSecondYesGeneratedAudio = this.scenario.parameters.questionSecondYesAudio
        } else {
          this.tmp.questionSecondYesLoadedAudio = this.scenario.parameters.questionSecondYesAudio
        }
        this.tmp.currentSpeakerSecondYes = this.scenario.parameters.questionSecondYesSpeaker || this.tmp.currentSpeakerSecondYes
        this.tmp.currentEmotionSecondYes = this.scenario.parameters.questionSecondYesEmotion || this.tmp.currentEmotionSecondYes
        this.tmp.currentSpeedSecondYes = this.scenario.parameters.questionSecondYesSpeed || this.tmp.currentSpeedSecondYes

        if (this.scenario.parameters.questionSecondYesYesGenerationState) {
          this.tmp.questionSecondYesYesGeneratedAudio = this.scenario.parameters.questionSecondYesYesAudio
        } else {
          this.tmp.questionSecondYesYesLoadedAudio = this.scenario.parameters.questionSecondYesYesAudio
        }
        this.tmp.currentSpeakerSecondYesYes = this.scenario.parameters.questionSecondYesYesSpeaker || this.tmp.currentSpeakerSecondYesYes
        this.tmp.currentEmotionSecondYesYes = this.scenario.parameters.questionSecondYesYesEmotion || this.tmp.currentEmotionSecondYesYes
        this.tmp.currentSpeedSecondYesYes = this.scenario.parameters.questionSecondYesYesSpeed || this.tmp.currentSpeedSecondYesYes

        if (this.scenario.parameters.questionSecondYesNoGenerationState) {
          this.tmp.questionSecondYesNoGeneratedAudio = this.scenario.parameters.questionSecondYesNoAudio
        } else {
          this.tmp.questionSecondYesNoLoadedAudio = this.scenario.parameters.questionSecondYesNoAudio
        }
        this.tmp.currentSpeakerSecondYesNo = this.scenario.parameters.questionSecondYesNoSpeaker || this.tmp.currentSpeakerSecondYesNo
        this.tmp.currentEmotionSecondYesNo = this.scenario.parameters.questionSecondYesNoEmotion || this.tmp.currentEmotionSecondYesNo
        this.tmp.currentSpeedSecondYesNo = this.scenario.parameters.questionSecondYesNoSpeed || this.tmp.currentSpeedSecondYesNo

        if (this.scenario.parameters.questionSecondNoGenerationState) {
          this.tmp.questionSecondNoGeneratedAudio = this.scenario.parameters.questionSecondNoAudio
        } else {
          this.tmp.questionSecondNoLoadedAudio = this.scenario.parameters.questionSecondNoAudio
        }
        this.tmp.currentSpeakerSecondNo = this.scenario.parameters.questionSecondNoSpeaker || this.tmp.currentSpeakerSecondNo
        this.tmp.currentEmotionSecondNo = this.scenario.parameters.questionSecondNoEmotion || this.tmp.currentEmotionSecondNo
        this.tmp.currentSpeedSecondNo = this.scenario.parameters.questionSecondNoSpeed || this.tmp.currentSpeedSecondNo

        if (this.scenario.parameters.questionSecondNoYesGenerationState) {
          this.tmp.questionSecondNoYesGeneratedAudio = this.scenario.parameters.questionSecondNoYesAudio
        } else {
          this.tmp.questionSecondNoYesLoadedAudio = this.scenario.parameters.questionSecondNoYesAudio
        }
        this.tmp.currentSpeakerSecondNoYes = this.scenario.parameters.questionSecondNoYesSpeaker || this.tmp.currentSpeakerSecondNoYes
        this.tmp.currentEmotionSecondNoYes = this.scenario.parameters.questionSecondNoYesEmotion || this.tmp.currentEmotionSecondNoYes
        this.tmp.currentSpeedSecondNoYes = this.scenario.parameters.questionSecondNoYesSpeed || this.tmp.currentSpeedSecondNoYes

        if (this.scenario.parameters.questionSecondNoNoGenerationState) {
          this.tmp.questionSecondNoNoGeneratedAudio = this.scenario.parameters.questionSecondNoNoAudio
        } else {
          this.tmp.questionSecondNoNoLoadedAudio = this.scenario.parameters.questionSecondNoNoAudio
        }
        this.tmp.currentSpeakerSecondNoNo = this.scenario.parameters.questionSecondNoNoSpeaker || this.tmp.currentSpeakerSecondNoNo
        this.tmp.currentEmotionSecondNoNo = this.scenario.parameters.questionSecondNoNoEmotion || this.tmp.currentEmotionSecondNoNo
        this.tmp.currentSpeedSecondNoNo = this.scenario.parameters.questionSecondNoNoSpeed || this.tmp.currentSpeedSecondNoNo
      }
    },
    beforeUpdate() {
      if (this.loadedScenario) {
        this.isSaved = true
        if (this.scenario.isReady) {
          this.isReady = this.scenario.isReady
          this.scenario = this.loadedScenario
          this.scenario.isReady = this.isReady
        } else {
          this.scenario = this.loadedScenario
        }

        if (this.scenario.parameters.questionFirstGenerationState) {
          this.tmp.questionFirstGeneratedAudio = this.scenario.parameters.questionFirstAudio
        } else {
          this.tmp.questionFirstLoadedAudio = this.scenario.parameters.questionFirstAudio
        }

        if (this.scenario.parameters.questionSecondYesGenerationState) {
          this.tmp.questionSecondYesGeneratedAudio = this.scenario.parameters.questionSecondYesAudio
        } else {
          this.tmp.questionSecondYesLoadedAudio = this.scenario.parameters.questionSecondYesAudio
        }

        if (this.scenario.parameters.questionSecondYesYesGenerationState) {
          this.tmp.questionSecondYesYesGeneratedAudio = this.scenario.parameters.questionSecondYesYesAudio
        } else {
          this.tmp.questionSecondYesYesLoadedAudio = this.scenario.parameters.questionSecondYesYesAudio
        }

        if (this.scenario.parameters.questionSecondYesNoGenerationState) {
          this.tmp.questionSecondYesNoGeneratedAudio = this.scenario.parameters.questionSecondYesNoAudio
        } else {
          this.tmp.questionSecondYesNoLoadedAudio = this.scenario.parameters.questionSecondYesNoAudio
        }

        if (this.scenario.parameters.questionSecondNoGenerationState) {
          this.tmp.questionSecondNoGeneratedAudio = this.scenario.parameters.questionSecondNoAudio
        } else {
          this.tmp.questionSecondNoLoadedAudio = this.scenario.parameters.questionSecondNoAudio
        }

        if (this.scenario.parameters.questionSecondNoYesGenerationState) {
          this.tmp.questionSecondNoYesGeneratedAudio = this.scenario.parameters.questionSecondNoYesAudio
        } else {
          this.tmp.questionSecondNoYesLoadedAudio = this.scenario.parameters.questionSecondNoYesAudio
        }

        if (this.scenario.parameters.questionSecondNoNoGenerationState) {
          this.tmp.questionSecondNoNoGeneratedAudio = this.scenario.parameters.questionSecondNoNoAudio
        } else {
          this.tmp.questionSecondNoNoLoadedAudio = this.scenario.parameters.questionSecondNoNoAudio
        }
      }
    }
  }

</script>

<style lang="scss" scoped>
  @import 'node_modules/bulma/sass/utilities/mixins';

  .spinner {
    margin-right: 5px;
  }

  p {
    margin-left: 10px;
    margin-right: 10px;
    margin-top: 10px;
  }

  .questionKey {
    display: inline-block;
    width:256px;
    margin-left: 16px;
    margin-top: -6px;
  }

</style>



// WEBPACK FOOTER //
// ScenarioTwoLevelYesNo.vue?b165c9fc